<!-- ============================================================== -->
<!-- Only router without any element -->
<!-- ============================================================== -->
<mat-sidenav-container [ngClass]="{
    'cardBorder': options.cardBorder,
    orange_theme: options.activeTheme == 'orange_theme',
    blue_theme: options.activeTheme == 'blue_theme',
    aqua_theme: options.activeTheme == 'aqua_theme',
    purple_theme: options.activeTheme == 'purple_theme',
    green_theme: options.activeTheme == 'green_theme',
    cyan_theme: options.activeTheme == 'cyan_theme'
  }"
                       [dir]="options.dir!" >



    <!-- ------------------------------------------------------------------
    Header
    ------------------------------------------------------------------ -->
    <!--<mat-toolbar class="topbar topbar-xl m-auto">
        <div class="container full-width p-xs-6">-->
            <!-- --------------------------------------------------------------- -->
            <!--<div class="branding p-x-0">
                <a href="/" *ngIf="options.theme === 'light'">
                    <img src="./assets/images/logos/dark-logo.svg"
                         class="align-middle m-2"
                         alt="logo" />
                </a>
                <a href="/" *ngIf="options.theme === 'dark'">
                    <img src="./assets/images/logos/light-logo.svg"
                         class="align-middle m-2"
                         alt="logo" />
                </a>
            </div>-->

            <!-- --------------------------------------------------------------- -->

            <!--<span class="flex-1-auto"></span>

            <div class="d-none d-lg-flex">-->
                <!-- --------------------------------------------------------------- -->
                <!--  Links -->
                <!-- --------------------------------------------------------------- -->
                
              <!--<div class="d-flex align-items-center m-x-20 w-100">
                <button mat-button class="m-x-10 f-s-16 f-w-500">
                  Home
                </button>
                <button mat-button class="m-x-10 f-s-16 f-w-500" [matMenuTriggerFor]="menu">
                  Courses
                </button>
                <mat-menu #menu="matMenu" class="cardWithShadow">
                  <button mat-menu-item>Item 1</button>
                  <button mat-menu-item>Item 2</button>
                </mat-menu>
                <a mat-button
                   class="m-x-10 f-s-16 f-w-500"
                   href="https://adminmart.com/support">Contact Us</a>
                <button mat-button class="m-x-10 f-s-16 f-w-500" (click)="login()" *ngIf="!user!.email&&!user!.tel">
                  Log In
                </button>
                <button mat-button class="m-x-10 f-s-16 f-w-500" (click)="profile()" *ngIf="user.email||user!.tel">
                  Profile
                </button>
                <button [matMenuTriggerFor]="flags" mat-icon-button class="m-r-5 m-x-10">
                  <img [src]="selectedLanguage.icon"
                       class="rounded-circle object-cover icon-20" />
                </button>
                <mat-menu #flags="matMenu" class="cardWithShadow">
                  <button mat-menu-item
                          *ngFor="let lang of languages"
                          (click)="changeLanguage(lang)">
                    <div class="d-flex align-items-center">
                      <img [src]="lang.icon"
                           class="rounded-circle object-cover m-r-8 icon-20" />
                      <span class="mat-subtitle-1 f-s-14">{{ lang.language }}</span>
                    </div>
                  </button>
                </mat-menu>
                <i-tabler name="phone-call"
                          class="icon-20"></i-tabler>
                <a class="m-x-8 f-s-12 m-y-7 f-w-2000" style="color: #041E42 ">+66(0)2 660 1234 กด 6</a>
              </div>
            </div>-->
            <!-- Mobile Menu -->
            <!--<button mat-icon-button
                    (click)="filterNavRight.toggle()"
                    class="d-flex d-lg-none">
                <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
            </button>-->
        <!--</div>
    </mat-toolbar>-->

    <!-- ------------------------------------------------------------------
    End Header
     ------------------------------------------------------------------ -->

    <router-outlet></router-outlet>

    <!-- ------------------------------------------------------------------
    footer
    ------------------------------------------------------------------ -->
    <!--<footer class="p-y-30" style="background-color:#041E42">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-sm-5 col-lg-4 text-center f-w-800 text-white">
                    <span>
                        <img src="assets/images/landingpage/favicon.png" alt="logo" />
                    </span>
                    <div class="f-s-14 m-t-8">
                        All rights reserved by Modernize. Designed & Developed by
                        <a [routerLink]="['https://adminmart.com/']"
                           class="mat-subtitle-2">AdminMart </a>.
                    </div>
                </div>
            </div>
        </div>
    </footer>-->

    <!-- ------------------------------------------------------------------
    end footer
    ------------------------------------------------------------------ -->
</mat-sidenav-container>
